// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from '../../../../elements/Modal/Modal';

import style from './Discover.scss';


type Props = {
  handleClose: (e: MouseEvent) => void;
  modalVisible: boolean;
  url: string;
};

export default class VideoModal extends Component<Props> {


  render() {
    const { handleClose, modalVisible, url } = this.props;
    return (
      <Modal key="modal"
             open={modalVisible}
             handleClose={handleClose}
             transparent={true}
             width={560}>
        {/* This is for unmount that dom element in order to stops when close */}
        {modalVisible &&
        <iframe src={url}
                className={style.iframe}
                frameBorder="0"
                allowFullScreen/>}
        <FormattedMessage id="home.mainBlock.button.close">{
          txt => <button className={style.close}
                         onClick={handleClose}
                         type="button">{txt}</button>
        }</FormattedMessage>
      </Modal>
    )
  }
}

VideoModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  modalVisible: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/home/elements/Discover/VideoModal.jsx